// src/components/about/ContactPerson.jsx
import React from 'react';
import { Phone, Mail, GlobeIcon } from 'lucide-react';

const ContactPerson = ({ person }) => {
  return (
    <div className="space-y-4 border-l-2 border-blue-100 pl-4">
      <div>
        <h4 className="font-medium text-gray-900">{person.name}</h4>
        <p className="text-sm text-gray-600">{person.description}</p>
      </div>
      
      {/* Contact Details */}
      <div className="space-y-2">
        {person.phone && (
          <div className="flex items-center">
            <Phone className="h-4 w-4 text-gray-400" />
            <a href={`tel:${person.phone}`} className="ml-2 text-gray-600 hover:text-gray-800">
              {person.phone}
            </a>
          </div>
        )}
        {person.email && (
          <div className="flex items-center">
            <Mail className="h-4 w-4 text-gray-400" />
            <a href={`mailto:${person.email}`} className="ml-2 text-gray-600 hover:text-gray-800">
              {person.email}
            </a>
          </div>
        )}
      </div>

      {/* Personal Links */}
      {person.values && person.values.length > 0 && (
        <div className="space-y-2">
          {person.values.map((link, index) => (
            <div key={index} className="flex items-center">
              <GlobeIcon className="h-4 w-4 text-gray-400" />
              <a
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="ml-2 text-blue-600 hover:text-blue-800 text-sm"
              >
                {link.name}
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContactPerson;